/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { AnalyticsError, AnalyticsEvent } from './AnalyticsConfig';

export default class AnalyticsChannelBase {
  // events and errors this channel should log, or undefined if all
  private events?: AnalyticsEvent[];
  private errors?: AnalyticsError[];

  constructor(events?: AnalyticsEvent[], errors?: AnalyticsError[]) {
    if (new.target === AnalyticsChannelBase) {
      throw new TypeError('Abstract class: Cannot construct AnalyticsChannelBase instances directly');
    }
    this.events = events;
    this.errors = errors;
  }

  public log(type: AnalyticsEvent, label?: string, additional?: string | number) {
    if (this.events === undefined || this.events.includes(type)) {
      const [category, action] = type.split('.');
      const value = typeof additional === 'number' ? additional : undefined;
      this._log(category, action, value, label, additional);
    }
  }

  public error(type: AnalyticsError, message?: string) {
    if (this.errors === undefined || this.errors.includes(type)) {
      this._error(type, message);
    }
  }

  protected _log(category: string, action: string, value?: number, label?: string, additional?: string | number) {}
  protected _error(type: AnalyticsError, message?: string) {}
}
